import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.CompanyAddressesStep.AddressFormPart', {
    buildingName: 'Building name',
    buildingNamePlaceholder: 'Enter building name...',
    buildingNumber: 'Number',
    buildingNumberPlaceholder: 'Enter number...',
    street: 'Street',
    streetPlaceholder: 'Enter street...',
    apNumber: 'Apartment number',
    apNumberPlaceholder: 'Enter apartment number...',
    stateOrProvince: 'State or province',
    stateOrProvincePlaceholder: 'Enter state or province...',
    city: 'City',
    cityPlaceholder: 'Enter city...',
    postalCode: 'Postal code',
    postalCodePlaceholder: 'Enter postal code...',
    country: 'Country',
});
